import React, { Component } from "react";
import { FileCopy } from "@material-ui/icons";
import axios from "axios";

export default class ExportTransaction extends Component {
  constructor(props) {
    super();
    this.state = {
      showDeleteModal: false,
      disableSubmit: false,
      status: 2,
    };
    this.handleshowDeleteModal = this.handleshowDeleteModal.bind(this);
  }

  handleshowDeleteModal = (e) => {
    this.setState({ showDeleteModal: !this.state.showDeleteModal });
  };

  handleSubmit = (e) => {
    axios({
      url: process.env.REACT_APP_API_LINK+"api/transaction_export/EARNING/"+this.props.company, //your url
      method: "GET",
      responseType: "blob", // important
    }).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Earning_Transaction.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
    
  };

  render() {
    return (
      <>
        <button
          className="btn btn-outline-secondary btn-sm float-right ml-2"
          title="Export Earning Transaction"
          onClick={this.handleSubmit}
        >
          <FileCopy /> Export Earning Transaction
        </button>
      </>
    );
  }
}
